import { FeatureModel } from "./feature.model";

export class Features {
    features?: FeatureModel[];
    constructor(data?: Partial<Features>) {
        Object.assign(this, data);
      }
  }
  